module.exports = __webpack_public_path__ + "static/media/DiscussPreview.8512331e.png";